var _circle, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "250 140 300 300",
    enableBackground: "new 0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeMiterlimit: 10,
    cx: 395.398,
    cy: 287.091,
    r: 123.434,
    className: "svg-circle"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "468.026,287.091 349.269,355.656 349.27,218.525 ",
    className: "svg-shape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -110.876,
    y: 231.631,
    display: "inline",
    width: 34.247,
    height: 101.369
  }), /*#__PURE__*/React.createElement("rect", {
    x: -56.767,
    y: 231.631,
    display: "inline",
    width: 34.247,
    height: 101.369
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.98b1fc7af37c0c589323fb9d0c962660.svg";
export { ForwardRef as ReactComponent };